import type { SendWhatsAppDTO } from '../types';
import { buildBasePayload } from './basePayload';
import type { WhatsAppPayload } from './basePayload';
import { API_WSP } from 'src/constants/conversations';
import { TWILIO_TEMPLATE_VERSIONS } from 'src/modules/models/templateTwilio/constants';

/**
 * Builds the request payload for Meta (WSP) provider.
 */
export function buildMetaPayload(dto: SendWhatsAppDTO): WhatsAppPayload {
    const base = buildBasePayload(dto);
    const payload: WhatsAppPayload = {
        to: dto.to,
        from: dto.from,
        ...base,
        api: API_WSP,
    };

    if (dto.templatePayload && !payload.templateType) {
        payload.templateType = TWILIO_TEMPLATE_VERSIONS.META_TEMPLATE;
    }

    return payload;
}
